module.exports = __webpack_public_path__ + "static/img/3.30c969d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/4/3.png
// module id = KzkN
// module chunks = 2